import { Button, Table, TableCard } from "@light-technology/components";
import { format } from "date-fns";
import { useNavigate } from "react-router";
import { api } from "../../state/api";
import { type AppResponse } from "../../state/api.types";
import { CreateWebhookModal } from "./CreateWebhookModal";

type WebhooksCardProps = {
  app: AppResponse;
};

export const WebhooksCard = (props: WebhooksCardProps) => {
  const navigate = useNavigate();
  const getWebhooks = api.useGetWebhooksQuery(props.app.uuid);
  return (
    <TableCard.Root>
      <TableCard.Header
        title="Webhooks"
        description={
          <>
            Receive real-time event notifications.{" "}
            <a
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
              href="https://docs.light.dev/webhooks"
            >
              Learn more
            </a>
          </>
        }
        contentTrailing={
          <CreateWebhookModal app={props.app}>
            <Button data-ph-capture-attribute-action="create-webhook">
              Create webhook
            </Button>
          </CreateWebhookModal>
        }
      />
      <Table
        aria-label="Webhooks"
        onRowClick={
          !getWebhooks.data?.data.length
            ? undefined
            : (row) => {
                navigate(
                  `/apps/${props.app.slug}/development/webhooks/${row.id as string}`,
                );
              }
        }
      >
        <Table.Header>
          <Table.Head isRowHeader id="id" label="ID" />
          <Table.Head id="url" label="URL" />
          <Table.Head id="created" label="Created" />
        </Table.Header>
        <Table.Body>
          {!getWebhooks.data?.data.length ? (
            <Table.Row>
              <Table.Cell colSpan={3}>
                <div className="flex flex-col items-center justify-center gap-lg p-5xl">
                  <div className="text-sm text-tertiary">
                    No webhooks created yet.
                  </div>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : (
            getWebhooks.data.data.map((webhook) => (
              <Table.Row key={webhook.uuid} id={webhook.uuid}>
                <Table.Cell>{webhook.uuid}</Table.Cell>
                <Table.Cell>{webhook.url}</Table.Cell>
                <Table.Cell>{format(webhook.created_at, "PPP")}</Table.Cell>
              </Table.Row>
            ))
          )}
        </Table.Body>
      </Table>
    </TableCard.Root>
  );
};
